import produce from "immer";

// Actions
export const LANDED = "landing/LANDED";
export const TYPE = "landing/TYPE";
export const PROGRESS = "landing/PROGRESS";

const initialState = {
  // User has visited before and made it past the choice screens
  landed: false,
  step: null,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  return produce(state, (draft) => {
    switch (action.type) {
      case LANDED: {
        draft.landed = action.landed;

        break;
      }
      case PROGRESS: {
        draft.step = action.step;

        break;
      }
    }
  });
}

// Action Creators
export function setLanded() {
  return { type: LANDED, landed: true };
}

export function setLandedFalse() {
  return { type: LANDED, landed: false };
}

export function setProgress(step) {
  return { type: PROGRESS, step };
}

// selector
export function selectLanding(state) {
  return state.landing;
}
